/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { ExternalScheduleSpreadsheet } from './external-schedule-spreadsheet';

@Injectable({
	providedIn: 'root',
})
export class SpreadsheetService {
	constructor() {}

	public getNewExternalScheduleSpreadsheet(): ExternalScheduleSpreadsheet {
		return new ExternalScheduleSpreadsheet();
	}
}
